import uniqBy from 'lodash/uniqBy';
import { Maybe, Review } from '../../../../__generated__/globalTypes';
import { ReviewFragment } from '../../__generated__/Reviews';

export type ReviewPhotos = {
  id: string;
  reviewId?: string;
  caption?: string;
  src?: string;
};

export const getUniqueImages = (
  reviewEdges?: Maybe<Maybe<{ review?: Maybe<Pick<Review, 'id'> & ReviewFragment> | undefined }>[]>,
  onePhotoPerReview = false,
): ReviewPhotos[] => {
  return uniqBy(
    (reviewEdges ?? [])
      // Gather all photos from reviews into a single array
      .flatMap((edge) => {
        const reviewPhotos = (edge?.review?.photos ?? []).map(
          (photo, index): ReviewPhotos => ({
            id: `${edge?.review?.id}_${index}`,
            reviewId: edge?.review?.id,
            caption: photo?.caption ?? '',
            src: photo?.fullImage || photo?.thumbnail || '',
          }),
        );

        if (onePhotoPerReview) {
          return reviewPhotos?.[0] ?? [];
        }
        return reviewPhotos;
      }),
    // Limit to unique src urls
    'src',
  );
};
